export enum LogoPositions {
    TOP_RIGHT = "topright",
    TOP_LEFT = "topleft",
    BOTTOM_RIGHT = "bottomright",
    BOTTOM_LEFT = "bottomleft"
}
